import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StatusAgendamentoService {
  stepStatus: any = {};
  infoPagamento: any = {};

  stepStatusChange: Subject<any> = new Subject<any>();

  paidWithPix: boolean

  constructor() {
    this.stepStatusChange.subscribe((value) => {
      this.stepStatus = value;
    });
  }

  setStepStatus(status) {
    this.stepStatusChange.next(status);
  }

  setInfoPagamento(json) {
    this.infoPagamento = json;
  }
}
